var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAlgeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8365 0 32 7.1635 32 16C32 24.8365 24.8365 32 16 32C16 31.3044 13.9131 16 13.9131 16L16 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.1635 32 0 24.8365 0 16C0 7.1635 7.1635 0 16 0",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4378 12.9312L18.1251 14.7402L15.999 14.0507L17.3139 15.8582L16.0013 17.6673L18.1265 16.9753L19.4414 18.7828L19.44 16.5477L21.5653 15.8557L19.4393 15.1663L19.4378 12.9312Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3278 20.5218C14.8305 20.5218 12.806 18.4973 12.806 16.0001C12.806 13.5028 14.8305 11.4783 17.3278 11.4783C18.1064 11.4783 18.8391 11.6752 19.4787 12.0218C18.4752 11.0405 17.1029 10.4348 15.5886 10.4348C12.515 10.4348 10.0234 12.9264 10.0234 16C10.0234 19.0736 12.5151 21.5652 15.5886 21.5652C17.103 21.5652 18.4753 20.9595 19.4787 19.9782C18.8391 20.3249 18.1064 20.5218 17.3278 20.5218Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAlgeria);
export default __webpack_public_path__ + "static/media/flag_algeria.e60bdf6c43e16829b3a724ec17ba3e67.svg";
export { ForwardRef as ReactComponent };